import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const GlobalControls = ({ 
  selectedDateRange, 
  onDateRangeChange, 
  selectedMetric, 
  onMetricChange, 
  comparisonMode, 
  onComparisonModeChange,
  onRefresh,
  isRefreshing 
}) => {
  const dateRangeOptions = [
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'last-7-days', label: 'Last 7 Days' },
    { value: 'last-30-days', label: 'Last 30 Days' },
    { value: 'last-90-days', label: 'Last 90 Days' },
    { value: 'this-month', label: 'This Month' },
    { value: 'last-month', label: 'Last Month' },
    { value: 'this-quarter', label: 'This Quarter' },
    { value: 'this-year', label: 'This Year' }
  ];

  const metricOptions = [
    { value: 'sales', label: 'Sales Performance' },
    { value: 'collections', label: 'Collection Efficiency' },
    { value: 'growth', label: 'Growth Rate' }
  ];

  const comparisonOptions = [
    { value: 'absolute', label: 'Absolute Values' },
    { value: 'percentage', label: 'Percentage Change' },
    { value: 'benchmark', label: 'vs Benchmark' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
        {/* Left Side Controls */}
        <div className="flex flex-col sm:flex-row sm:items-center space-y-4 sm:space-y-0 sm:space-x-4">
          <Select
            label="Date Range"
            options={dateRangeOptions}
            value={selectedDateRange}
            onChange={onDateRangeChange}
            className="w-full sm:w-48"
          />
          
          <Select
            label="Performance Metric"
            options={metricOptions}
            value={selectedMetric}
            onChange={onMetricChange}
            className="w-full sm:w-48"
          />
          
          <Select
            label="Comparison Mode"
            options={comparisonOptions}
            value={comparisonMode}
            onChange={onComparisonModeChange}
            className="w-full sm:w-48"
          />
        </div>

        {/* Right Side Actions */}
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onRefresh}
            disabled={isRefreshing}
          >
            <Icon 
              name="RefreshCw" 
              size={14} 
              className={isRefreshing ? 'animate-spin' : ''}
            />
            Refresh
          </Button>
          
          <Button variant="outline" size="sm">
            <Icon name="Download" size={14} />
            Export
          </Button>
          
          <Button variant="outline" size="sm">
            <Icon name="Settings" size={14} />
            Configure
          </Button>
        </div>
      </div>

      {/* Quick Stats Bar */}
      <div className="mt-4 pt-4 border-t border-border">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          <div className="text-center">
            <div className="text-lg font-semibold text-foreground">12</div>
            <div className="text-xs text-muted-foreground">Active Companies</div>
          </div>
          <div className="text-center">
            <div className="text-lg font-semibold text-success">8</div>
            <div className="text-xs text-muted-foreground">Above Target</div>
          </div>
          <div className="text-center">
            <div className="text-lg font-semibold text-warning">3</div>
            <div className="text-xs text-muted-foreground">At Risk</div>
          </div>
          <div className="text-center">
            <div className="text-lg font-semibold text-error">1</div>
            <div className="text-xs text-muted-foreground">Needs Attention</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalControls;